import clsx from "clsx";
import { useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { selectCurrentUser, selectIsAuth, selectIsLogin } from "../../features/authentication/services";
import { useAppSelector } from "../../hooks";
import PageLoader from "../loader/PageLoader";
import TopNav from "../nav/TopNav";
import styles from "./PrivateLayout.module.scss";

const drawerWidth = 240;

const PrivateLayout = () => {
    const isLogin = useAppSelector(selectIsLogin);
    const isAuth = useAppSelector(selectIsAuth);
    const isSaleMode = !!useAppSelector(selectCurrentUser)?.salesAccountId;
    const [sideBarOpen, setSideBarOpen] = useState(true);
    const handleSideBarOpen = () => {
        setSideBarOpen(!sideBarOpen);
    };

    if (!isLogin) {
        return isAuth === "loading" ? <PageLoader loading={true} /> : <Navigate to='/' replace />;
    }
    return (
        <>
            <div className={clsx(styles.box, { [styles.saleMode]: isSaleMode, [styles.sideBarOpen]: sideBarOpen })}>
                <TopNav drawerWidth={drawerWidth} sideBarOpen={sideBarOpen} handleSideBarOpen={handleSideBarOpen} />
                <main className={styles.main}>
                    {/* <Toolbar /> */}
                    <Outlet />
                </main>
            </div>
        </>
    );
};
export default PrivateLayout;
